module.exports = __webpack_public_path__ + "img/active-guize.c0e06518.png";